export const showSidebarSelector = (state) => state.view.showSidebar;
export const showBackBtnSelector = (state) => state.view.showBackBtn;

export const getPageName = (state) => state.view.pageName;
